// Route path registered by BOTH apps (dashboard and firmware webconfig) for the client-endpoint API
// docs page, so shared components can link to it with a plain react-router path under either app's
// basename. Lives in its own module so linking to the page doesn't pull the docs (and the embedded
// OpenAPI specs) into the importer's bundle.
export const ENDPOINT_API_DOCS_PATH = "/endpoint-api-docs";

// Which spec the page shows is selected by query string rather than by a separate route per partner,
// so adding a spec needs no routing change in either app — only a registry entry.
export const ENDPOINT_API_DOCS_SPEC_PARAM = "spec";

/** Link target for a specific spec id from the registry (see specRegistry.ts). */
export const endpointApiDocsPath = (specId: string): string =>
    `${ENDPOINT_API_DOCS_PATH}?${ENDPOINT_API_DOCS_SPEC_PARAM}=${encodeURIComponent(specId)}`;

/**
 * Absolute URL for a spec, for link sites that can't route to the page themselves.
 *
 * The docs page is hosted by the dashboard only — the device WebConfig deliberately does NOT bundle it
 * (the OpenAPI viewer is several megabytes and the firmware image pays for every byte), so WebConfig links
 * out instead of rendering its own copy.
 *
 * `origin` is supplied by the caller rather than hard-coded here: the firmware already derives the right
 * dashboard for the environment it's talking to (`ApiHelper.DashboardUrl`, surfaced on `/settings` as
 * `dashboardUrl`), and duplicating that as a front-end constant would send staging devices to production.
 */
export const endpointApiDocsUrl = (origin: string, specId: string): string =>
    `${origin.replace(/\/$/, "")}${endpointApiDocsPath(specId)}`;
